import { IconAlertTriangleFilled } from '@tabler/icons-react';

const FONT = '"Public Sans", sans-serif';

export default function ModalEliminarVariante({ isOpen, onClose, onConfirm, variantName }) {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center p-3"
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.72)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
      }}
      onClick={onClose}
    >
      <div
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="eliminar-variante-titulo"
        aria-describedby="eliminar-variante-descripcion"
        className="flex flex-col overflow-hidden w-full"
        style={{
          backgroundColor: '#000',
          borderRadius: '28px',
          border: '1px solid rgba(255, 255, 255, 0.16)',
          maxWidth: '420px',
          boxShadow: '0 40px 120px rgba(0, 0, 0, 0.8)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="shrink-0 px-5 sm:px-6 pt-5 sm:pt-6 pb-4 border-b border-white/[0.16]">
          <h2
            id="eliminar-variante-titulo"
            className="font-semibold m-0 truncate"
            style={{
              fontSize: '22px',
              lineHeight: '28px',
              letterSpacing: '-0.02em',
              color: 'rgba(255, 255, 255, 0.95)',
              fontFamily: FONT,
            }}
          >
            Eliminar variante
          </h2>
          <p
            className="m-0 mt-1"
            style={{
              fontSize: '13px',
              lineHeight: '18px',
              fontWeight: 500,
              color: 'rgba(255, 255, 255, 0.45)',
              fontFamily: FONT,
            }}
          >
            Esta acción no se puede deshacer
          </p>
        </div>

        <div className="px-5 sm:px-6 py-5">
          <div
            className="flex items-center gap-3 rounded-[20px] p-4"
            style={{ backgroundColor: 'rgba(248, 124, 43, 0.08)' }}
          >
            <span
              className="flex items-center justify-center shrink-0 w-10 h-10 rounded-full"
              style={{ backgroundColor: 'rgba(248, 124, 43, 0.14)' }}
            >
              <IconAlertTriangleFilled size={19} color="#f87c2b" />
            </span>
            <span
              id="eliminar-variante-descripcion"
              className="min-w-0"
              style={{
                fontSize: '15px',
                lineHeight: '21px',
                fontWeight: 600,
                letterSpacing: '-0.01em',
                color: 'rgba(255, 255, 255, 0.92)',
                fontFamily: FONT,
              }}
            >
              "{variantName}" se eliminará permanentemente
            </span>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row sm:justify-end gap-2 shrink-0 px-5 sm:px-6 py-4 border-t border-white/[0.16]">
          <button
            type="button"
            onClick={onClose}
            className="flex items-center justify-center h-12 px-6 rounded-full border-none cursor-pointer touch-manipulation select-none transition-colors duration-200 ease-out active:scale-[0.98] [@media(hover:hover)]:hover:bg-white/[0.1]"
            style={{
              backgroundColor: 'rgba(255, 255, 255, 0.06)',
              fontSize: '14px',
              fontWeight: 600,
              letterSpacing: '-0.01em',
              color: 'rgba(255, 255, 255, 0.9)',
              fontFamily: FONT,
            }}
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="flex items-center justify-center h-12 px-7 rounded-full border-none cursor-pointer touch-manipulation select-none transition-colors duration-200 ease-out active:scale-[0.98] [@media(hover:hover)]:hover:brightness-110"
            style={{
              backgroundColor: '#ff453a',
              fontSize: '15px',
              fontWeight: 600,
              letterSpacing: '-0.01em',
              color: '#fff',
              fontFamily: FONT,
            }}
          >
            Eliminar
          </button>
        </div>
      </div>
    </div>
  );
}
